var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArmWithHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.38 27.29C41.87 24.25 48.76 16.64 48.76 9.98004C48.76 6.29004 45.77 3.29004 42.07 3.29004C38.83 3.29004 36.02 5.60004 35.38 8.66004C34.74 5.60004 31.93 3.29004 28.69 3.29004C25 3.29004 22 6.28004 22 9.98004C22 17.37 28.88 24.25 35.38 27.29V27.29Z",
    stroke: "#EB731A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1704 43.7602H42.1904C44.1004 43.7602 45.6504 42.2102 45.6504 40.3002C45.6504 38.3902 44.1004 36.8402 42.1904 36.8402H32.2704C30.3804 36.8402 28.4904 36.6302 26.6604 36.1502C25.1304 35.7502 22.8504 35.4002 20.1904 35.7602C15.3204 36.4202 10.8004 40.0702 8.69043 44.3902L18.9604 54.9202C21.7404 52.1402 25.4504 50.5102 29.3804 50.3302L41.0904 49.8102C44.2104 49.6702 47.1704 48.3702 49.3904 46.1602L57.8404 38.2002C59.2004 36.9202 59.2604 34.7802 57.9904 33.4202C56.7104 32.0602 54.5804 31.9902 53.2204 33.2602L45.6804 40.2902",
    stroke: "#010101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.19 56.8401L15.03 62.0001L2 47.9701L7.16 42.8101L20.19 56.8401Z",
    stroke: "#010101",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmWithHeart);
export default __webpack_public_path__ + "static/media/arm-with-heart.63ebc8876eecaade9a6c9f5a5f31f917.svg";
export { ForwardRef as ReactComponent };